<!-- <div class="container-fluid line1">
  <div class="col-xs-12 line2">
    <div class="topbar">
      <a href="#" class="btn btn-md search">
         Search<span class="search-img"><img src="assets/search.jpg"></span>
      </a>
      <button class="btn top-link app">Download App <i class="fa fa-android" aria-hidden="true"></i> <span><i class="fa fa-apple"></i></span></button>
        <span class="top-link">Need Help?</span>
        <span class="top-link">Login | Sign Up</span>
      
    </div>
  </div>
</div> -->

<div *ngIf="loggedIn" class="container-fluid line">
  <div class="container">
    <div class="col-lg-4 col-md-4 col-xs-12 col-sm-4">
      {{brandData?.email}}
    </div>
    <div class="col-lg-5 col-md-5 col-xs-12 col-sm-5 user3" *ngIf="loggedIn">
      <div
        class="btn-group edit-profile"
        *ngIf="ayurAdmin_role != 'AyurwayAdmin'"
      >
        <button
          type="button"
          class="dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          (click)="member_role == 'member' ? getPointsmember() : none"
        >
          <i class="bi bi-list"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            type="button"
            *ngIf="member_role == 'member'"
          >
            <span
              >My Credits &nbsp;&nbsp;<span>{{ points }}</span></span
            >
          </button>

          <button
            class="dropdown-item pointer"
            type="button"
            *ngIf="doctor_role == 'doctor'"
            routerLink="/doctor-profile"
          >
            Edit Profile
          </button>
          <button
            class="dropdown-item pointer"
            type="button"
            *ngIf="member_role == 'member'"
            routerLink="/member-profile"
          >
            Edit Profile
          </button>
          <!-- <button class="dropdown-item" type="button">Change Password</button> -->
        </div>
      </div>
      <ngx-avatar
        class="avatar"
        name="{{ userProfile?.firstName | titlecase }}"
        size="35"
        [round]="true"
      ></ngx-avatar>
      <p class="username">
        {{ doctor_role == "doctor" ? "Dr." : ""
        }}{{ userProfile?.firstName | titlecase }}
      </p>
    </div>

    <div class="col-lg-3 col-md-3 col-xs-12 col-sm-3 user3"></div>
  </div>
</div>

<div class="container-fluid header-bg">
  <div class="row">
    <div class="row">
      <div class="row">
        <div class="col-lg-1 col-md-1 col-xs-1">
          <!-- <a class="navbar-brand" routerLink="/products"> -->
          <a  routerLink="/products">  
            <!-- <img src="{{imgPath.default[0].app_logoPath}}" class="navbarimg" /> -->
            <img src="{{brandData?.mailLogo}}" style="height: 110px; margin-left: 20px;" />
          </a>
        </div>
        <div class="col-lg-11 col-md-11 col-xs-11">
          <!-- Brand and toggle get grouped for better mobile display -->
          <nav class="navbar">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#bs-example-navbar-collapse-1"
                aria-expanded="false"
              >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>

            <!-- Collect the nav links, forms, and other content for toggling -->
            <div
              class="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
              *ngIf="!loggedIn"
            >
              <ul class="nav navbar-nav navbar-right">
                <!-- <li>
                  <a
                    routerLink="/products"
                    routerLinkActive="myactive"
                    rel="noreferrer"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Products</a
                  >
                </li> -->

                <li>
                  <a routerLink="/about" routerLinkActive="myactive"
                    >Home</a
                  >
                </li>
                <li>
                  <a routerLink="/team" routerLinkActive="myactive">Team</a>
                </li>
                <li>
                  <a routerLink="/wellness" routerLinkActive="myactive"
                    >Wellness</a
                  >
                </li>
                <!-- <li>
                  <a routerLink="/service" routerLinkActive="myactive"
                    >Services</a
                  >
                </li> -->

                <li>
                  <a routerLink="/talktodoctor" routerLinkActive="myactive"
                    >Talk to Doctor</a
                  >
                </li>
                <li>
                  <a routerLink="/providercorner" routerLinkActive="myactive"
                    >Provider Corner</a
                  >
                </li>
                <li>
                  <a routerLink="/contactus" routerLinkActive="myactive"
                    >Contact Us</a
                  >
                </li>
                <!-- <li>
                  <a routerLink="/other" routerLinkActive="myactive"
                    >Other</a
                  >
                </li> -->
                <li>
                  <select
                    class="selectdomain selectpicker nav-link"
                    id="selectdomain"
                    tabindex="-98"
                    [(ngModel)]="secCountryID"
                    (change)="selectCountry(secCountryID)"
                  >
                    <option value="1" class="option">IND</option>
                    <!-- <option value="#">UAE</option> -->
                    <option value="2">USA</option>
                  </select>
                </li>
                <li>
                  <a routerLink="/login" routerLinkActive="myactive">Login</a>
                </li>
              </ul>
            </div>

            <div
              class="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
              *ngIf="loggedIn && ayurAdmin_role != 'AyurwayAdmin'"
            >
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <a
                    routerLink="/products"
                    routerLinkActive="myactive"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Products</a
                  >
                </li>

                <!-- <li><a routerLink="/wellness"  routerLinkActive="myactive" >Wellness</a></li> -->
                <li *ngIf="member_role == 'member'">
                  <!-- <a
                    href="{{ baseUrl }}"
                    target="_blank"
                    routerLinkActive="myactive"
                    >Wellness</a
                  > -->
                  <a
                  href="{{ wellnessUrl }}"
                  target="_blank"
                  routerLinkActive="myactive"
                  >Wellness</a
                >
                </li>

                <li>
                  <a routerLink="/service" routerLinkActive="myactive"
                    >Services</a
                  >
                </li>
                <li *ngIf="member_role == 'member'">
                  <a
                    routerLink="/talktodoctor"
                    class="menu-a"
                    role="button"
                    routerLinkActive="myactive"
                    >Talk to Doctor</a
                  >
                </li>
                <li>
                  <a
                    *ngIf="member_role == 'member'"
                    routerLink="/myappoinment"
                    routerLinkActive="myactive"
                    >Appointments</a
                  >
                </li>
                <li *ngIf="doctor_role == 'doctor'">
                  <a
                    routerLink="/providercorner"
                    class="menu-a"
                    routerLinkActive="myactive"
                    >Provider Corner</a
                  >
                </li>
                <li>
                  <a
                    *ngIf="doctor_role == 'doctor'"
                    routerLink="/doctorappoinment-list"
                    routerLinkActive="myactive"
                    >Appointments List</a
                  >
                </li>
                <li>
                  <a routerLink="/contactus" routerLinkActive="myactive"
                    >Contact Us</a
                  >
                </li>
                <li>
                  <select
                    class="selectdomain selectpicker nav-link"
                    id="selectdomain"
                    tabindex="-98"
                    [(ngModel)]="secCountryID"
                    (change)="selectCountry()"
                  >
                    <option value="1" class="option">IND</option>
                    <!-- <option value="#">UAE</option> -->
                    <option value="2">USA</option>
                  </select>
                </li>
                <li class="pointer"><a (click)="loggedOut()">Logout</a></li>
              </ul>
            </div>

            <!-- Admin Navigation-->
            <div
              class="collapse navbar-collapse"
              id="bs-example-navbar-collapse-1"
              *ngIf="loggedIn && ayurAdmin_role == 'AyurwayAdmin'"
            >
              <ul class="nav navbar-nav navbar-right">
                <!-- <li><a routerLink="/admin/home" routerLinkActive="myactive" [routerLinkActiveOptions]="{exact:true}">Home</a></li> -->
                <li>
                  <a
                    routerLink="/admin/all-appointmentlist"
                    routerLinkActive="myactive"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >All Appointments</a
                  >
                </li>
                <li>
                  <a routerLink="/admin/doctorlist" routerLinkActive="myactive"
                    >Doctor</a
                  >
                </li>
                <li>
                  <a routerLink="/admin/memberlist" routerLinkActive="myactive"
                    >Member</a
                  >
                </li>
                <li>
                  <a routerLink="/admin/home" routerLinkActive="myactive"
                    >Inbox</a
                  >
                </li>
                <li>
                  <a
                    routerLink="/admin/emr-registerslists"
                    routerLinkActive="myactive"
                    >Emr</a
                  >
                </li>
                <li>
                  <a routerLink="/admin/service" routerLinkActive="myactive"
                    >Services</a
                  >
                </li>
                <li class="pointer"><a (click)="loggedOut()">Logout</a></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
